// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from './http'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@acs/style.css'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// 引入一套图标
// import '@acs/font-awesome.min.css'
// 关闭生产模式下给出的提示
Vue.config.productionTip = false
Vue.http = Vue.prototype.$http = axios

// Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

// 更新美钥码ID的函数
Vue.prototype.getNewQrId = function (id, type) {
  var result = ''
  if (type === 'WEBSITE') {
    result = 'U'
  } else if (type === 'TEXT') {
    result = 'T'
  } else if (type === 'WEIXIN') {
    result = 'W'
  } else if (type === 'IDCARD') {
    result = 'I'
  }
  for (var i = 0; i < 6 - String(id).length; i++) {
    result = result + '0'
  }
  result = result + String(id)
  return result
}
